import type { ConversationResultDTO } from '@nora-monorepo/nora-api-client';

interface HasUserRoleBeenUpdatedConversationInputType {
  users: {
    user: {
      id: string;
    };
    localRole: {
      id: string;
    };
  }[];
}

interface HasAnyGroupRoleBeenUpdatedConversationInputType {
  groups: {
    group: {
      id: string;
    };
    localRole: {
      id: string;
    };
  }[];
}

export function hasUserRoleBeenUpdated(
  conversation: HasUserRoleBeenUpdatedConversationInputType,
  updated: ConversationResultDTO,
  userId: string,
): boolean {
  const currentUser = conversation.users.find(
    user => user.user.id === userId,
  );

  const updatedUser = updated.users.find(user => user.user.id === userId);

  if (!currentUser || !updatedUser) {
    return false;
  }

  return currentUser.localRole.id !== updatedUser.localRole.id;
}

export function hasAnyGroupRoleBeenUpdated(
  conversation: HasAnyGroupRoleBeenUpdatedConversationInputType,
  updated: ConversationResultDTO,
): boolean {
  for (const currentGroup of conversation.groups) {
    const updatedGroup = updated.groups.find(
      group => group.group.id === currentGroup.group.id,
    );

    if (!updatedGroup) {
      continue;
    }

    if (currentGroup.localRole !== updatedGroup.localRole) {
      return true;
    }
  }
  return false;
}
